"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get LAB_FILE_ALLOWED_CONTENT_TYPES () {
        return _labfiles.LAB_FILE_ALLOWED_CONTENT_TYPES;
    },
    get LAB_FILE_MAX_BYTES () {
        return _labfiles.LAB_FILE_MAX_BYTES;
    },
    get LAB_FILE_NOT_AVAILABLE () {
        return _labfiles.LAB_FILE_NOT_AVAILABLE;
    },
    get LAB_FILE_OPAQUE_CONTENT_TYPE () {
        return _labfiles.LAB_FILE_OPAQUE_CONTENT_TYPE;
    },
    get LAB_FILE_OPAQUE_KINDS () {
        return _labfiles.LAB_FILE_OPAQUE_KINDS;
    },
    get LAB_QUARANTINE_NOT_OPEN () {
        return _quarantine.LAB_QUARANTINE_NOT_OPEN;
    },
    get LAB_RESULT_IN_QUARANTINE () {
        return _labresultmove.LAB_RESULT_IN_QUARANTINE;
    },
    get LAB_RESULT_IN_SIGNED_NOTE () {
        return _labresultmove.LAB_RESULT_IN_SIGNED_NOTE;
    },
    get LAB_RESULT_MOVE_RETRY () {
        return _labresultmove.LAB_RESULT_MOVE_RETRY;
    },
    get LAB_RESULT_MOVE_SAME_PATIENT () {
        return _labresultmove.LAB_RESULT_MOVE_SAME_PATIENT;
    },
    get LabFileKindSchema () {
        return _labfiles.LabFileKindSchema;
    },
    get LabFileListResponseSchema () {
        return _labfiles.LabFileListResponseSchema;
    },
    get LabFileRejectReasonSchema () {
        return _labfiles.LabFileRejectReasonSchema;
    },
    get LabFileSchema () {
        return _labfiles.LabFileSchema;
    },
    get LabFileStatusSchema () {
        return _labfiles.LabFileStatusSchema;
    },
    get LabQuarantineCountResponseSchema () {
        return _quarantine.LabQuarantineCountResponseSchema;
    },
    get LabQuarantineDetailSchema () {
        return _quarantine.LabQuarantineDetailSchema;
    },
    get LabQuarantineDismissReasonSchema () {
        return _quarantine.LabQuarantineDismissReasonSchema;
    },
    get LabQuarantineDismissRequestSchema () {
        return _quarantine.LabQuarantineDismissRequestSchema;
    },
    get LabQuarantineDismissResponseSchema () {
        return _quarantine.LabQuarantineDismissResponseSchema;
    },
    get LabQuarantineListItemSchema () {
        return _quarantine.LabQuarantineListItemSchema;
    },
    get LabQuarantineListQuerySchema () {
        return _quarantine.LabQuarantineListQuerySchema;
    },
    get LabQuarantineListResponseSchema () {
        return _quarantine.LabQuarantineListResponseSchema;
    },
    get LabQuarantinePatientDetailsSchema () {
        return _quarantine.LabQuarantinePatientDetailsSchema;
    },
    get LabQuarantineResolveRequestSchema () {
        return _quarantine.LabQuarantineResolveRequestSchema;
    },
    get LabQuarantineResolveResponseSchema () {
        return _quarantine.LabQuarantineResolveResponseSchema;
    },
    get LabQuarantineStatusSchema () {
        return _quarantine.LabQuarantineStatusSchema;
    },
    get LabResultFlagSchema () {
        return _labresult.LabResultFlagSchema;
    },
    get LabResultListItemSchema () {
        return _labresult.LabResultListItemSchema;
    },
    get LabResultListQuerySchema () {
        return _labresult.LabResultListQuerySchema;
    },
    get LabResultListResponseSchema () {
        return _labresult.LabResultListResponseSchema;
    },
    get LabResultMatchedBySchema () {
        return _labresult.LabResultMatchedBySchema;
    },
    get LabResultMoveReasonSchema () {
        return _labresultmove.LabResultMoveReasonSchema;
    },
    get LabResultMoveRefActionSchema () {
        return _labresultmove.LabResultMoveRefActionSchema;
    },
    get LabResultMoveRequestSchema () {
        return _labresultmove.LabResultMoveRequestSchema;
    },
    get LabResultMoveResponseSchema () {
        return _labresultmove.LabResultMoveResponseSchema;
    },
    get LabResultReviewResponseSchema () {
        return _labresult.LabResultReviewResponseSchema;
    },
    get LabResultSchema () {
        return _labresult.LabResultSchema;
    },
    get LabResultStatusSchema () {
        return _labresult.LabResultStatusSchema;
    },
    get LabSyncStatusSchema () {
        return _syncstatus.LabSyncStatusSchema;
    },
    get OEM_REF_LINKED_TO_OTHER_PATIENT () {
        return _quarantine.OEM_REF_LINKED_TO_OTHER_PATIENT;
    },
    get PatientExternalRefListResponseSchema () {
        return _quarantine.PatientExternalRefListResponseSchema;
    },
    get PatientExternalRefSchema () {
        return _quarantine.PatientExternalRefSchema;
    },
    get isLabFileOpaqueKind () {
        return _labfiles.isLabFileOpaqueKind;
    },
    get isLabFileTypeAllowed () {
        return _labfiles.isLabFileTypeAllowed;
    },
    get labFileServedContentType () {
        return _labfiles.labFileServedContentType;
    }
});
const _labresult = require("./lab-result");
const _quarantine = require("./quarantine");
const _labfiles = require("./lab-files");
const _labresultmove = require("./lab-result-move");
const _syncstatus = require("./sync-status");
